module.exports = __webpack_public_path__ + "resource/img/image055.1db2539f.png";